import Color from '@platform-ui/common/utilities/Color.js';
import { Link as ReactRouterLink, LinkProps } from 'react-router-dom';
import Typography, { Variant } from '../Typography/index.js';

export interface CustomLinkProps extends LinkProps {
  external?: boolean;
  variant?: Variant;
  bold?: boolean;
}

// This is basically an extension of react-router's that applies our
// correct styling.
export default function Link({
  children,
  external = false,
  variant = 'body',
  bold = true,
  ...rest
}: CustomLinkProps): JSX.Element {
  const copy = (
    <Typography variant={variant} tag="span" color={Color.Link} bold={bold}>
      {children}
    </Typography>
  );
  if (external) {
    const { className, rel, to, target } = rest;
    return (
      <a href={to as string} target={target} rel={rel} className={className}>
        {copy}
      </a>
    );
  }
  return <ReactRouterLink {...rest}>{copy}</ReactRouterLink>;
}
